/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Adjustreason2Inputs */

const zh_adminsubs_adjustreason2 = /** @type {(inputs: Adminsubs_Adjustreason2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原因`)
};

const en_adminsubs_adjustreason2 = /** @type {(inputs: Adminsubs_Adjustreason2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason`)
};

const es_adminsubs_adjustreason2 = /** @type {(inputs: Adminsubs_Adjustreason2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razón`)
};

/**
* | output |
* | --- |
* | "Reason" |
*
* @param {Adminsubs_Adjustreason2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_adjustreason2 = /** @type {((inputs?: Adminsubs_Adjustreason2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Adjustreason2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_adjustreason2(inputs)
	if (locale === "en") return en_adminsubs_adjustreason2(inputs)
	return es_adminsubs_adjustreason2(inputs)
});
export { adminsubs_adjustreason2 as "adminSubs_adjustReason" }